import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FontPicker from '../../common/font-picker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Slider from 'material-ui/Slider';
import ColorPicker from '../../common/color-picker';
import StyledColorBlock from '../../common/styled-color-block';


import { chartActions, getChart } from '../../../core/chart';
import { _Field, _Slider, _Label } from '../styled-sidebar';
import theme from '../../../styles/theme';

import { uiActions } from '../../../core/ui';
import { StyledScrollable, StyledMargin } from '../../common/styled-base';

class ChartMenu extends React.Component {

  render() {
    const { 
      chart,
      setAngle, 
      setAngleOffset, 
      setGenerations, 
      setFont, 
      setMargin, 
      setStrokeWidth, 
      setStrokeColor, 
      setTextTransform 
    } = this.props;


    return (
      <StyledScrollable padding='15px'>

        <_Field>
          <_Label>Generations: {chart.generations}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={4} 
              max={10} 
              step={1} 
              value={chart.generations} 
              onChange={(e, value) => setGenerations(value)} />
          </_Slider>
        </_Field>

        <_Field>
          <_Label>Font</_Label>
          <FontPicker
            value={chart.font}
            onChange={font => setFont(font)} />
        </_Field>

        <_Field>
          <_Label>Angle: {chart.angle}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={0} 
              max={360} 
              step={1} 
              value={chart.angle}
              onChange={(e, value) => setAngle(value)} />
          </_Slider>
        </_Field>

        <_Field>
          <_Label>Angle Offset: {chart.angleOffset}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={0} 
              max={360} 
              step={1} 
              value={chart.angleOffset}
              onChange={(e, value) => setAngleOffset(value)} />
          </_Slider>
        </_Field>


        <_Field>
          <_Label>Margin: {chart.margin}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={20} 
              max={500} 
              step={1} 
              value={chart.margin}
              onChange={(e, value) => setMargin(value)} />
          </_Slider>
        </_Field>

        <_Field>
          <_Label>Line Width: {chart.strokeWidth}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={0} 
              max={10} 
              step={1} 
              value={chart.strokeWidth}
              onChange={(e, value) => {setStrokeWidth(value);}} />
          </_Slider>
        </_Field>

        <_Field>
          <_Label>Line Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={chart.strokeColor} onChange={(color) => setStrokeColor(color.hex)}>
              <StyledColorBlock color={chart.strokeColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field>
          <_Label>Text Transform</_Label>
          <SelectField
            className="kt-select"
            value={chart.textTransform}
            labelStyle={{color: 'rgba(255,255,255,0.8)'}}
            selectedMenuItemStyle={{color: theme.primary}}
            onChange={(e, index, value) => setTextTransform(value)}
            >
            <MenuItem value={"none"} primaryText="Normal" />
            <MenuItem value={"uppercase"} primaryText="Uppercase" />
          </SelectField>
        </_Field>

      </StyledScrollable>
    )
  }
}

const mapStateToProps = createSelector(
  getChart,
  (chart) => ({
    chart,
  })
)

const mapDispatchToProps = Object.assign({}, chartActions, uiActions)

export default connect(mapStateToProps, mapDispatchToProps)(ChartMenu);


// WEBPACK FOOTER //
// ./src/components/menu/chart-menu/index.js